// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs-container {
  display: flex;
  justify-content: space-between;
  margin: 23px 0 0px 0;
}

.custom-tab {
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
  color: #405261;
  text-transform: none;
  border: none;
  background-color: transparent;
  outline: none;
  border-bottom: 1px solid transparent;
  margin-right: 20px; /* Space between tabs */
  border-radius: 4px 4px 0 0; /* Rounded corners at the top of the tabs */
  transition: background-color 0.3s, color 0.3s; /* Smooth transition effects */
}
.custom-tab:first-child {
  /* margin-right: 20px; */
}
.custom-tab.selected {
  font-size: 14px;
  line-height: 18px;
  color: #061522;
  font-style: normal;
  font-weight: 500;
  border-bottom: 1px solid #1976d2;
}
.canned-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.custom-tab-content {
  padding: 16px;
  border: 1px solid #e0e0e0; /* Border around the tab content */
  border-radius: 0 0 4px 4px; /* Rounded corners at the bottom of the content area */
}
.canned-response {
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #061522;
  margin-bottom: 5px;
}
.canned-review-response {
  color: #405261;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.search-input-canned {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 336px;
}
.canned-msg-count {
  color: #405261;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: right;
  margin-top: 16px;
  margin-bottom: 37px;
}
.canned-msg-box {
  border: 1px solid #e5e9ec;
  border-radius: 8px;
  padding: 24px;
}
.canned-listing {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5px;
}

.canned-view-more {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.canned-msg-box:hover {
  background: #f3fbff;
  border: 1px solid #148dfd;
}

.canned-box-top {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500 !important;
  font-family: "Inter" !important;
  color: #061522;
}

.canned-box-mid {
  margin: 18px 0 28px 0;
  font-size: 14px;
  line-height: 18px;
  color: #405261;
}

.canned-box-bottom {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #061522;
  gap: 8px;
}

.canned-box-bottom img {
  border-radius: 50%;
}
.canned-msg-box .icons-container {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
  gap: 8px;
}

.canned-msg-box:hover .icons-container {
  opacity: 1;
  background: #f3fbff;
}

/* Existing box hover */
.canned-msg-box:hover {
  background: #f3fbff;
}
.sidebar-canned {
  padding: 32px;
}
.canned-main {
  padding: 16px 24px;
}
.canned-top-container {
  display: flex;
  gap: 8px;
}
.new-canned-response {
  border-radius: 8px;
  background: #148dfd;
  border: none;
  color: #fff;
  outline: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  width: 208px;
  height: 40px;
  margin-top: 8px;
}

.ticketStatus {
  border-radius: 5px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  width: 64px;
  padding: 4px 0px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}

.ToAssignInput_Container {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  /* max-width: 650px;
  width: 100%; */
}

.ToAssignInput_Container p {
  display: flex;
  justify-content: center;
  padding: 0px 8px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.AssignInput_Container_dropdown {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
}

.AssignInput_Container_dropdown p {
  padding-left: 9px;
  display: flex;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ToAssignli_hover {
  height: 64px;
}
.ToAssignli_hover:hover {
  border-radius: 4px;
  border: 0.5px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}

.Assignli_hover {
  height: 64px;
}
.Assignli_hover:hover {
  border-radius: 4px;
  border: 0.5px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}

.tag-input {
  max-width: 200px;
}

.group-select-search {
  width: 280px;
  height: 40px;
}
/* ✅ Responsive Design for Mobile Screens */

@media (max-width: 880px) {
  .canned-review-response {
    font-size: 14px !important;
  }
  .canned-listing {
    flex-direction: column; /* stack vertically */
    align-items: flex-start;
    gap: 8px; /* spacing between input and button */
  }
  .custom-tabs-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .custom-tab {
    font-size: 13px !important;
    padding: 6px 12px !important;
  }

  .canned-msg-box {
    padding: 12px !important;
    font-size: 14px !important;
  }

  .canned-box-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .icons-container {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
  }

  .canned-box-bottom {
    flex-wrap: wrap;
    font-size: 12px;
  }

  .canned-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (max-width: 480px) {
  .canned-main {
    padding: 0 12px;
  }

  .search-input-canned {
    width: 100%;
    margin-bottom: 10px;
  }

  .canned-msg-box {
    font-size: 13px !important;
    padding: 10px !important;
  }

  .custom-tabs-container {
    gap: 4px;
  }

  .canned-msg-count {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ProfileComponents/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,oCAAoC;EACpC,kBAAkB,EAAE,uBAAuB;EAC3C,0BAA0B,EAAE,2CAA2C;EACvE,6CAA6C,EAAE,8BAA8B;AAC/E;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB,EAAE,kCAAkC;EAC7D,0BAA0B,EAAE,sDAAsD;AACpF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD;gBACc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA,2CAA2C;;AAE3C;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB,EAAE,qBAAqB;IAC7C,uBAAuB;IACvB,QAAQ,EAAE,qCAAqC;EACjD;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".custom-tabs-container {\n  display: flex;\n  justify-content: space-between;\n  margin: 23px 0 0px 0;\n}\n\n.custom-tab {\n  padding: 8px 0;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 18px;\n  color: #405261;\n  text-transform: none;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  border-bottom: 1px solid transparent;\n  margin-right: 20px; /* Space between tabs */\n  border-radius: 4px 4px 0 0; /* Rounded corners at the top of the tabs */\n  transition: background-color 0.3s, color 0.3s; /* Smooth transition effects */\n}\n.custom-tab:first-child {\n  /* margin-right: 20px; */\n}\n.custom-tab.selected {\n  font-size: 14px;\n  line-height: 18px;\n  color: #061522;\n  font-style: normal;\n  font-weight: 500;\n  border-bottom: 1px solid #1976d2;\n}\n.canned-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n.custom-tab-content {\n  padding: 16px;\n  border: 1px solid #e0e0e0; /* Border around the tab content */\n  border-radius: 0 0 4px 4px; /* Rounded corners at the bottom of the content area */\n}\n.canned-response {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 18px;\n  color: #061522;\n  margin-bottom: 5px;\n}\n.canned-review-response {\n  color: #405261;\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n.search-input-canned {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  width: 336px;\n}\n.canned-msg-count {\n  color: #405261;\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-align: right;\n  margin-top: 16px;\n  margin-bottom: 37px;\n}\n.canned-msg-box {\n  border: 1px solid #e5e9ec;\n  border-radius: 8px;\n  padding: 24px;\n}\n.canned-listing {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 5px;\n}\n\n.canned-view-more {\n  margin-top: 24px;\n  display: flex;\n  justify-content: center;\n}\n.canned-msg-box:hover {\n  background: #f3fbff;\n  border: 1px solid #148dfd;\n}\n\n.canned-box-top {\n  display: flex;\n  justify-content: space-between;\n  font-size: 18px;\n  font-weight: 500 !important;\n  font-family: \"Inter\" !important;\n  color: #061522;\n}\n\n.canned-box-mid {\n  margin: 18px 0 28px 0;\n  font-size: 14px;\n  line-height: 18px;\n  color: #405261;\n}\n\n.canned-box-bottom {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  color: #061522;\n  gap: 8px;\n}\n\n.canned-box-bottom img {\n  border-radius: 50%;\n}\n.canned-msg-box .icons-container {\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.canned-msg-box:hover .icons-container {\n  opacity: 1;\n  background: #f3fbff;\n}\n\n/* Existing box hover */\n.canned-msg-box:hover {\n  background: #f3fbff;\n}\n.sidebar-canned {\n  padding: 32px;\n}\n.canned-main {\n  padding: 16px 24px;\n}\n.canned-top-container {\n  display: flex;\n  gap: 8px;\n}\n.new-canned-response {\n  border-radius: 8px;\n  background: #148dfd;\n  border: none;\n  color: #fff;\n  outline: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  width: 208px;\n  height: 40px;\n  margin-top: 8px;\n}\n\n.ticketStatus {\n  border-radius: 5px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  width: 64px;\n  padding: 4px 0px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.ToAssignInput_Container {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  /* max-width: 650px;\n  width: 100%; */\n}\n\n.ToAssignInput_Container p {\n  display: flex;\n  justify-content: center;\n  padding: 0px 8px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.AssignInput_Container_dropdown {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n}\n\n.AssignInput_Container_dropdown p {\n  padding-left: 9px;\n  display: flex;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ToAssignli_hover {\n  height: 64px;\n}\n.ToAssignli_hover:hover {\n  border-radius: 4px;\n  border: 0.5px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n\n.Assignli_hover {\n  height: 64px;\n}\n.Assignli_hover:hover {\n  border-radius: 4px;\n  border: 0.5px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n\n.tag-input {\n  max-width: 200px;\n}\n\n.group-select-search {\n  width: 280px;\n  height: 40px;\n}\n/* ✅ Responsive Design for Mobile Screens */\n\n@media (max-width: 880px) {\n  .canned-review-response {\n    font-size: 14px !important;\n  }\n  .canned-listing {\n    flex-direction: column; /* stack vertically */\n    align-items: flex-start;\n    gap: 8px; /* spacing between input and button */\n  }\n  .custom-tabs-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .custom-tab {\n    font-size: 13px !important;\n    padding: 6px 12px !important;\n  }\n\n  .canned-msg-box {\n    padding: 12px !important;\n    font-size: 14px !important;\n  }\n\n  .canned-box-top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .icons-container {\n    display: flex;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n\n  .canned-box-bottom {\n    flex-wrap: wrap;\n    font-size: 12px;\n  }\n\n  .canned-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .canned-main {\n    padding: 0 12px;\n  }\n\n  .search-input-canned {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .canned-msg-box {\n    font-size: 13px !important;\n    padding: 10px !important;\n  }\n\n  .custom-tabs-container {\n    gap: 4px;\n  }\n\n  .canned-msg-count {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
